import {
  formatCurrencyData,
  formatDateToFinanceDate,
  formatTextData,
  getCurrentTimestamp
} from "@saleor/reports/utils/misc";
import { reportsDownload } from "@saleor/reports/utils/utils";
import _ from "lodash";

import { ActiveBatchDetailsReport_activeBatchDetailsReport_edges_node } from "../types/ActiveBatchDetailsReport";

export const createReportStructure = (
  reportData: ActiveBatchDetailsReport_activeBatchDetailsReport_edges_node[],
  filename: string
) => {
  const blankFields = ["created", "completed_at"];
  const currenyFields = [
    "total_retail_price",
    "sale_discount_tenant",
    "sale_discount_sm",
    "sale_discount_total",
    "subtotal",
    "shipping_cost",
    "total_gross_transaction",
    "voucher_discount_tenant",
    "voucher_discount_sm",
    "discount_amount",
    "price_paid",
    "payment_fee",
    "payment_fee_vat",
    "payment_fee_adjustment",
    "payment_fee_adjustment_vat",
    "total_payment_fee",
    "payment_fee_witholding_tax",
    "delivery_fee_adjustment",
    "credit_card_witholding_tax",
    "other_adjustment",
    "net_settlement"
  ];
  const dateFields = ["settlement_date"];
  const textFields = ["mall_name", "legal_name", "brand_name"];

  const selectedReportData = reportData
    .map(data => ({ ...data }))
    .map(data => {
      delete data.__typename;

      data.id = atob(data.id);

      Object.entries(data).forEach(([key, value]) => {
        if (currenyFields.includes(key)) {
          data[key] = formatCurrencyData(value);
          return;
        }

        if (value === null) {
          data[key] = "";
          return;
        }

        if (dateFields.includes(key)) {
          data[key] = formatDateToFinanceDate(value);
        }

        if (textFields.includes(key)) {
          data[key] = formatTextData(value, "UPC");
          return;
        }

        if (blankFields.includes(key)) {
          data[key] = "";
          return;
        }
      });

      const filteredData = Object.keys(data)
        .filter(key =>
          Object.keys(reportsDownload?.activeBatchPayouts?.fields).includes(key)
        )
        .reduce(
          (cur, key) => Object.assign(cur, { [key]: String(data[key]) }),
          {}
        );

      return filteredData;
    });

  return {
    data: selectedReportData,
    fields: reportsDownload.activeBatchPayouts.fields,
    filename: `${filename.replace(/-/, "_")}-${getCurrentTimestamp()}`,
    sheetname: filename.replace(/-/, " ")
  };
};
